import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrReportMetric.ts
var t = () => e("reportMetric");
//#endregion
export { t as useTrReportMetric };
